"use client";

import { ShopAddressPageResourceShops } from "@/api/generated-api";
import S from "./index.module.scss";
import { FC } from "react";
import CustomIcon from "@/components/ui/custom-icon";
import { useStore } from "@/hooks/system/useStore";
import { observer } from "mobx-react-lite";

const escapeRegExp = (str: string) => {
  return str.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
};

const highlightText = (text: string, query: string): string => {
  if (!query.trim()) return text;

  const escapedQuery = escapeRegExp(query.trim());
  const regex = new RegExp(`(${escapedQuery})`, "gi");

  return text.replace(regex, "<strong>$1</strong>");
};

interface IAddressesItem {
  item: ShopAddressPageResourceShops;
}

const AddressesItem: FC<IAddressesItem> = ({ item }) => {
  const { query, map } = useStore("addresses");
  const { address, title, phone } = item;

  const handleAddressClick = () => {
    map?.flyTo([Number(item.lat), Number(item.lon)], 14);
  };

  return (
    <li className={S.wrapper} onClick={handleAddressClick}>
      <CustomIcon fileName="map-location-icon" />
      <div className={S.info}>
        <h4
          className={S.title}
          dangerouslySetInnerHTML={{
            __html: highlightText(title, query),
          }}
        />
        <div className={S.addressWrapper}>
          <span
            className={S.address}
            dangerouslySetInnerHTML={{
              __html: highlightText(address, query),
            }}
          />
          {phone && <span className={S.phone}>{phone}</span>}
        </div>
      </div>
    </li>
  );
};

export default observer(AddressesItem);
